import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorageService } from '@services/core/storage/storage.service';
import { hasValue } from '@src/app/shared/utils/helpers';

@Injectable({
  providedIn: 'root'
})
export class LastViewedPatientService {
  private readonly lsKey = 'lastViewedPatientId';

  private patientIdSubject: BehaviorSubject<string>;
  public patientId$: Observable<string>;

  constructor(private storage: StorageService) {
    const stored = this.storage.getItem<string>(this.lsKey) as string;
    this.patientIdSubject = new BehaviorSubject<string>(stored);
    this.patientId$ = this.patientIdSubject.asObservable();
  }

  public setPatientId(id: string): void {
    if (hasValue(id)) {
      this.storage.setItem(this.lsKey, id);
    } else {
      this.storage.removeItem(this.lsKey);
    }
    this.patientIdSubject.next(id);
  }

  public get patientId(): string {
    return this.patientIdSubject.getValue();
  }
}
